import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})
export class ImageSliderComponent implements OnInit {

  @Input() activeSideMenu: any;
  @Input() gisMapComp: any;
  @ViewChild('imageGrid', { static: false }) imageGrid!: ElementRef;
  @ViewChild('imageModal', { static: false }) imageModal!: TemplateRef<any>;

  selectedImage: string = '';
  currentImageIndex: number = 0;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  scrollLeft() {
    this.imageGrid.nativeElement.scrollBy({
      left: -200,  // adjust scroll distance
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.imageGrid.nativeElement.scrollBy({
      left: 200,   // adjust scroll distance
      behavior: 'smooth'
    });
  }

  closePanel() {
    this.gisMapComp.isImageSliderOpen = false
  }

  get imageList(): string[] {
    return this.gisMapComp && this.gisMapComp.imageList ? this.gisMapComp.imageList : [];
  }

  openModal(image: string, index: number) {
    this.selectedImage = image;
    this.currentImageIndex = index;
    this.modalService.open(this.imageModal, { size: 'lg', centered: true });
  }

  showPreviousImage() {
    if (this.currentImageIndex <= 0) {
      return;
    }
    this.currentImageIndex--;
    this.selectedImage = this.imageList[this.currentImageIndex];
  }

  showNextImage() {
    if (this.currentImageIndex >= this.imageList.length - 1) {
      return;
    }
    this.currentImageIndex++;
    this.selectedImage = this.imageList[this.currentImageIndex];
  }

  get isFirstImage(): boolean {
    return this.currentImageIndex === 0;
  }

  get isLastImage(): boolean {
    return this.currentImageIndex === this.imageList.length - 1;
  }


}
